import React from 'react'

import RoutesPublic from 'modulesPublic/RoutesPublic'

const MainLayoutPublic = () => (
  <div id='public'>
    <section id='loginForm'>
      <div>
        <div className='logo'>
          <div/>
        </div>

        <RoutesPublic/>
      </div>
    </section>
  </div>
)

export default MainLayoutPublic
